import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { Button, useModalControl } from '@frontend/design-system';
import { AddEditServiceTypeTray } from '../../components/service-type-modal';
import { ServiceTypesSettingsTrackingIds } from '../../trackingIds/service-types-settings-tracking';

type Props = {
  locationId: string;
};

export const NewServiceTypeButton = ({ locationId }: Props) => {
  const { t } = useTranslation('schedule-settings');
  const { modalProps, triggerProps } = useModalControl();
  const { isIntegratedOffice } = DataSourcesQueries.useGetAccessibleIntegrations();

  if (!locationId || isIntegratedOffice) return null;

  return (
    <>
      <Button
        {...triggerProps}
        size='large'
        onClick={(event) => {
          SchedulerV3.trackPendoEvent(ServiceTypesSettingsTrackingIds.events.newServiceClicked, { locationId });
          triggerProps.onClick(event);
        }}
      >
        {t('New Service')}
      </Button>
      <AddEditServiceTypeTray
        variant={'core'}
        selectedServiceDetails={null}
        locationId={locationId}
        modalProps={modalProps}
        onClose={modalProps.onClose}
      />
    </>
  );
};
